/**
 * The Spanish catalogue for the way in — the wording only. Why each entry exists is argued in
 * `en/entry.ts`.
 *
 * NEUTRAL Spanish, no voseo (`CLAUDE.md` rule 2): the product is played in several countries and voseo
 * belongs to one of them: the neutral second person throughout, never the voseo imperative.
 */
export default {
  // ── the menu ──────────────────────────────────────────────────────────────────────────────────────
  menu_title: 'Elige cómo jugar',
  menu_solo: 'Nueva partida',
  menu_solo_sub: 'Tú contra los bots — {n} por lado.',
  menu_host: 'Abrir una partida',
  menu_host_sub: 'La hospedas desde esta máquina y reparte el código. Hasta doce.',
  menu_join: 'Entrar con un código',
  menu_join_sub: 'Alguien abrió una partida y te dio su código.',
  menu_group: 'Partidas grupales',
  menu_group_sub: 'El campo compartido de este servidor: entras y juegas con los que ya están dentro. Sin sala, sin código y sin invitación.',
  menu_options: 'Opciones',
  menu_options_sub: 'Sensibilidad, volumen y pantalla.',
  menu_signout: 'Cerrar sesión',
  menu_signout_sub: 'Sal de esta cuenta y vuelve a la puerta.',
  menu_credits: 'Créditos',
  menu_credits_sub: 'Quién hizo esto y con qué está hecho.',

  // ── the two boxes the menu opens (mode 1) ─────────────────────────────────────────────────────────
  host_label: 'Nombre de la partida',
  host_ph: 'Escaramuza del sábado',
  host_note: 'Es lo que ven los invitados mientras esperan. Después va el campo, y ahí se verifica esta máquina.',
  host_go: 'Elegir el campo',
  join_label: 'El código',
  join_ph: 'el código, o el enlace entero',
  join_note: 'No eliges el campo: ya lo eligió quien abrió la partida.',
  join_go: 'Entrar',

  // ── the credits ───────────────────────────────────────────────────────────────────────────────────
  credits_title: 'Créditos',
  credits_sub: 'A-ARENA es el campo de tiro táctico multijugador de A-Airsoft: el mismo motor de balística que corre en el simulador del teléfono, resuelto en un servicio autoritativo y dibujado en el navegador.',
  credit_product: 'Producto y dirección',
  credit_product_who: 'Germán Zelaya',
  credit_code: 'Desarrollo',
  credit_code_who: 'Germán Zelaya · Claude (Anthropic)',
  credit_engine: 'Motor balístico',
  credit_engine_who: 'Compartido con el simulador de A-Airsoft: arrastre, hop-up, viento y rebote. Una sola descripción, tres runtimes.',
  credit_tech: 'Tecnología',
  credit_tech_who: 'Babylon.js · TypeScript · Node.js · WebSocket · WebRTC',
  credit_art: 'Escenografía y modelos',
  credit_art_who: 'Catálogo propio, medido y horneado para este campo, sobre assets de terceros con licencia.',
  credits_foot: 'Balística real, tácticas reales. Nada de lo que decide un impacto se dibuja dos veces.',

  // ── the mode ──────────────────────────────────────────────────────────────────────────────────────
  mode_title: 'Elige la modalidad',

  // ── the field ─────────────────────────────────────────────────────────────────────────────────────
  fields_title: 'Elige el campo',
  fields_sub: 'Al elegir se descarga todo lo que el campo necesita. La espera es una sola y ocurre acá.',
  field_plan: 'plano',
  live: 'en juego',
  pick_again: 'Toca otra vez para confirmar',
  lefty: `Modo zurdo`,
  lefty_note: `Espeja los controles en pantalla para el pulgar izquierdo. Los glifos no se dan vuelta.`,

  // ── identity ──────────────────────────────────────────────────────────────────────────────────────
  identity_title: 'Quién eres',
  identity_sub: 'El alias es lo que los demás leen en la cinta de tu espalda.',
  identity_alias: 'Alias',
  // The label when the gate NAMED this browser: the field above it is a readout and not an
  // input, so calling a real callsign "alias" would be the screen contradicting what it shows.
  identity_callsign: 'Indicativo',
  avatar_title: 'Tu cuerpo',
  avatar_sub: 'Solo estético: todos los cuerpos miden lo mismo para el disparo.',
  identity_random: 'El que me toque',
  /**
   * «BANDO» Y NO «EQUIPO», y no es una preferencia de estilo. En esta misma pantalla, tres renglones
   * más arriba, la identidad ya dibuja el EQUIPO de la persona — el que trae el plano de coordinación
   * (`ArenaIdentity`). Son dos objetos distintos: uno es a quién pertenece y el otro es de qué lado del
   * campo se para. Llamarlos igual acá sería `arena.md §C` con la palabra a la vista de los dos.
   */
  side_label: 'Bando',
  side_auto: 'El que me toque',
  identity_operator_m: 'Operador',
  identity_operator_f: 'Operadora',

  // ── group ─────────────────────────────────────────────────────────────────────────────────────────
  group_title: 'Tu grupo',
  group_sub: 'El escudo va cosido a la espalda y a la manga. Es identidad, no bando: no dice de qué lado juegas ni cambia nada de lo que se puntúa.',
  group_none: 'Sin grupo',

  // ── the marcadora ─────────────────────────────────────────────────────────────────────────────────
  marker_title: 'Tu marcadora',
  marker_sub: 'El modelo que quieres en las manos. Casi todos son un look: el precinto —lo que decide el mecanismo, la mínima y el cargador— se elige en el paso siguiente. El cerrojo es la excepción, y su renglón lo dice: elegirlo ES elegir su categoría.',
  marker_side: 'La de mi bando',
  marker_side_sub: 'La que el campo arma para tu lado. Cambia si cambias de lado.',
  /** The heading of the panel that reads back what the reel has landed on. One key for both reels. */
  chosen: 'Elegido',

  // ── the seal ──────────────────────────────────────────────────────────────────────────────────────
  seal_title: 'Tu precinto',
  seal_sub: 'Opcional: es el TOPE de energía con el que entras, y decide el modo de fuego, el cargador y la distancia mínima. Si no eliges, entras con el que arme el campo. Dentro del tope, la velocidad, el gramaje y el hop se ajustan con la L.',
  seal_field: 'La del campo',
  seal_field_sub: 'El precinto por defecto de la sala.',
  seal_min: 'mínima {n} m',
  seal_nomin: 'sin mínima',

  // ── the viewer's readout ──────────────────────────────────────────────────────────────────────────
  readout_alias: 'ALIAS',
  readout_callsign: 'INDICATIVO',
  readout_group: 'GRUPO',
  readout_hands: 'EN MANOS',
  alias_ph: 'tu alias',

  // ── options and pause ─────────────────────────────────────────────────────────────────────────────
  tune_title: 'Ajuste fino',
  tune_sub: 'Opcional: dentro del tope de tu precinto puedes mover la velocidad, el gramaje y el hop. Es el mismo panel que abre la L en el campo, y no cambia ni el mecanismo ni la mínima.',
  options_title: 'Opciones',
  options_back: 'Volver al campo',
  controls_hint: 'Los controles se ven con {key}, dibujados sobre un teclado — dentro del campo y sin salir de la partida.',
  preview_hint: 'arrastra para girar · rueda para acercar',
  rearm_note: 'Rearma la sesión: todos los que estén jugando recargan.',
  seal_fixed_note: 'Dentro de ese tope, la velocidad, el gramaje y el hop se ajustan en el campo con la L.',
  options_language: 'Idioma',
  options_sensitivity: 'Sensibilidad del mouse',
  options_volume: 'Volumen',
  options_bots: 'Bots por lado',
  options_bots_less: 'menos bots',
  options_bots_more: 'más bots',
  options_bots_note: 'Cuántos enemigos y compañeros trae una partida nueva.',
  options_image: 'Imagen',
  options_image_note: 'Cómo se revela el campo. Se dialó en una pantalla — muévelo hasta que se vea bien en la tuya.',
  options_image_reset: 'Volver a la del campo',
  options_image_tone: 'Curva de tono',
  options_tone_off: 'Ninguna',
  options_tone_standard: 'Estándar',
  options_tone_aces: 'ACES',
  options_tone_neutral: 'Neutra',
  options_image_exposure: 'Brillo',
  options_image_contrast: 'Contraste',
  options_image_env: 'Reflejos',
  options_image_env_note: 'Ilumina las superficies con el propio cielo. Apagado cuesta menos en una máquina modesta.',
  options_image_strength: 'Fuerza de los reflejos',
  options_image_strength_off: 'Solo hace algo con los reflejos encendidos.',
  fullscreen: 'Pantalla completa al entrar',
  fullscreen_blocks: 'Además bloquea CTRL+W, que en una pestaña normal cierra el juego sin preguntar.',
  fullscreen_cannot: 'Este navegador no permite bloquear CTRL+W — al cerrar te pide confirmación igual.',
  pause_title: 'Pausa',
  pause_sub: 'El juego sigue corriendo.',
  pause_watch: 'Mirar el campo',
  pause_back: 'Volver al campo',
  pause_back_sub: 'Retoma el control. La partida nunca dejó de correr.',
  pause_change_field: 'Cambiar de campo',
  pause_leave: 'Abandonar la partida',
  pause_leave_sub: 'Suelta tu cuerpo y cierra el enlace. Vuelves a la pantalla de entrada.',
  spent_title: 'SIN MUNICIÓN',
  spent_sub: 'Se te acabaron los cargadores y las granadas: tu partida terminó. Empieza una nueva desde aquí.',

  alias_set: 'entras como {name}',

  // ── shared controls ───────────────────────────────────────────────────────────────────────────────
  next: 'Continuar',
  enter: 'Entrar al campo',
  back: '◄ Volver',
  mode_skirmish: `Escaramuza`,
  mode_skirmish_sub: `Un impacto te saca de la ronda. Gana el bando que queda en pie, o el que tiene más vivos cuando suena el reloj.`,
  mode_ctf: `Captura la bandera`,
  mode_ctf_sub: `Lleva la bandera del otro bando hasta la tuya. Con la bandera en la mano solo se usa la secundaria.`,
};
